<template>
  <div id="tests">
    <div class="container" style="padding-top: 0px" v-if="data != null">
      <div class="row" v-if="question != null && index != null">
        <div
          class="col-md-12 d-flex align-items-center justify-content-between"
          style="border-radius: 10px; padding: 10px 15px"
        >
          <h3 style="font-size: 21px" class="dark-inverted">
            {{ part.title }} -
            <a
              href="javascript:;"
              style="color: #ffb62e"
              @click="$router.back()"
              >Ara Ver</a
            >
          </h3>
          <h3 class="dark-inverted">
            {{ part.answer_count }}/{{ part.question_count }}
          </h3>
        </div>
        <div class="col-md-12">
          <h4
            class="text-center description dark-inverted"
            style="
              font-weight: 400;
              font-size: 22px;
              margin: 30px 0px 20px;
              font-style: italic;
            "
          >
            {{ question.description }}
          </h4>
        </div>
        <div class="col-md-12">
          <div class="progress mt-3 mb-3 pl-0 pr-0">
            <div
              class="progress-bar"
              role="progressbar"
              style="height: 100%; background-color: #ffb62e"
              :style="{
                width: (part.answer_count / part.question_count) * 100 + '%',
              }"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
        <div
          class="col-md-12 question"
          v-for="(question, questionIndex) in question.questions"
        >
          <h2
            class="text-center dark-inverted"
            v-if="question.title_type == 'text'"
            style="font-size: 27px; margin: 30px 0px"
          >
            {{ question.title }}
          </h2>
          <div
            class="col-md-12 d-flex align-items-center justify-content-center"
            v-if="question.title_type == 'image'"
          >
            <img :src="'https://olcek360.com/' + question.title" />
          </div>
          <div
            class="col-md-12 d-flex align-items-center justify-content-center"
            :class="isMobile ? 'flex-column' : ''"
          >
            <span
              class="dark-inverted"
              v-if="
                question.left_description != null &&
                question.left_description != '' &&
                !isMobile &&
                question.options.some((x) => x.point == x.title) == true
              "
              >{{ question.left_description }}</span
            >
            <div
              class="d-flex align-items-center justify-content-center"
              v-if="
                question.options.length > 0 &&
                question.options[0].title == question.options[0].point
              "
            >
              <div
                class="d-flex option"
                @click="next(question, option)"
                :style="{
                  width: getSize(optionIndex, questionIndex).size + 10 + 'px',
                  height: getSize(optionIndex, questionIndex).size + 10 + 'px',
                  borderColor: '#1c449c',
                }"
                v-for="(option, optionIndex) in question.options"
                style="
                  border-radius: 50%;
                  align-items: center;
                  justify-content: center;
                  border: 3px solid #ddd;
                "
              >
                <span style="font-size: 20px" class="dark-inverted">{{
                  option.title
                }}</span>
              </div>
            </div>
            <div class="dark-inverted" v-else>
              <div
                class="text-option"
                v-for="option in question.options"
                @click="next(question, option)"
              >
                {{ option.title }}
              </div>
            </div>
            <span
              class="dark-inverted"
              v-if="
                question.right_description != null &&
                question.right_description != '' &&
                !isMobile &&
                question.options.some((x) => x.point == x.title) == true
              "
              >{{ question.right_description }}</span
            >
            <div
              class="d-flex w-100"
              v-if="isMobile"
              style="justify-content: space-between"
            >
              <span
                class="dark-inverted"
                v-if="
                  question.right_description != null &&
                  question.right_description != '' &&
                  question.options.some((x) => x.point == x.title) == true
                "
                >{{ question.left_description }}</span
              >
              <span
                class="dark-inverted"
                v-if="
                  question.right_description != null &&
                  question.right_description != '' &&
                  question.options.some((x) => x.point == x.title) == true
                "
                >{{ question.right_description }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-md-12 d-flex align-items-center flex-column">
          <h3
            class="text-center dark-inverted"
            style="font-size: 40px; font-weight: bold"
          >
            {{ part.title }} Tamamlandı
          </h3>
          <p
            class="text-center mt-3 mb-3 dark-inverted"
            style="font-size: 20px"
          >
            Bu kısımdaki
            <strong class="dark-inverted">{{ part.question_count }}</strong>
            soruyu cevapladınız.<br />
            Eğer varsa geri dönüp diğer bölümleri çözebilir veya testin tümünü
            tamamladıysanız raporlara gözatabilirsiniz.
          </p>
          <a
            @click="$router.back()"
            href="javascript:;"
            class="button h-button is-danger is-rounded"
            >Geri Dön</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
document.documentElement.style.setProperty("--animate-duration", ".5s");
import _ from "lodash";
import axios from "axios";
import $ from "jquery";
export default {
  name: "TestDetail",
  data() {
    return {
      data: null,
      questions: [],
      index: null,
      question: null,
      date: new Date().getTime(),
      test_id: this.$route.params.test_id,
      part_id: this.$route.params.part_id,
      lock: false,
      part: {
        question_count: 0,
        answer_count: 0,
      },
      isMobile: $(window).width() <= 768,
    };
  },
  async created() {
    axios
      .post("account/getQuestions", {
        test_id: this.test_id,
        part_id: this.part_id,
      })
      .then((res) => {
        this.data = res.data.data;

        this.questions = _.shuffle(
          this.data.question_groups.map((question_group) => {
            return {
              ...question_group,
              questions: this.data.questions
                .filter(
                  (k) => k.question_group_id == question_group.question_group_id
                )
                .map((question) => {
                  return {
                    ...question,
                    options: this.data.options
                      .filter((k) => k.question_id == question.question_id)
                      .map((option) => {
                        return {
                          ...option,
                        };
                      }),
                  };
                }),
            };
          })
        );

        this.part = this.data.part;

        if (this.questions.length > 0) {
          $(".question").addClass("animate_animated animate__zoomIn");
          this.index = 0;
          this.question = this.questions[this.index];
        }
      });
  },
  methods: {
    getSize(index, questionIndex) {
      if (this.index == null || this.questions.length == 0) {
        return "";
      }
      var sizes = [];
      var colors = [];
      if (this.question.questions[questionIndex].options.length == 2) {
        sizes = ["50", "50"];
        colors = ["red", "blue"];
      }
      if (this.question.questions[questionIndex].options.length == 3) {
        sizes = ["50", "40", "50"];
        colors = ["red", "gray", "blue"];
      }
      if (this.question.questions[questionIndex].options.length == 4) {
        sizes = ["50", "50", "50", "50"];
        colors = ["red", "orange", "darkgreen", "blue"];
      }
      if (this.question.questions[questionIndex].options.length == 5) {
        sizes = ["50", "40", "30", "40", "50"];
        colors = ["red", "orange", "gray", "darkgreen", "blue"];
      }
      if (this.question.questions[questionIndex].options.length == 6) {
        sizes = ["50", "45", "40", "40", "45", "50"];
        colors = ["red", "orange", "gray", "darkgreen", "blue", "blue"];
      }
      if (this.question.questions[questionIndex].options.length == 7) {
        sizes = ["50", "45", "40", "35", "40", "45", "50"];
        colors = [
          "red",
          "orange",
          "gray",
          "darkgreen",
          "blue",
          "darkgreen",
          "blue",
        ];
      }
      return {
        size: parseInt(sizes[index]),
        color: colors[index],
      };
    },
    next(question, option) {
      if (this.lock) return;
      this.lock = true;

      $(".question").addClass("animate__animated animate__flipOutX");

      axios
        .post("account/saveAnswer", {
          test_id: this.test_id,
          part_id: this.part_id,
          question_id: question.question_id,
          question_group_id: this.question.question_group_id,
          option_id: option.option_id,
          question: question.title,
          answer: option.point,
          time: (new Date().getTime() - this.date) / 1000,
        })
        .then((res) => {
          if (this.index + 1 == this.questions.length) {
            this.index = null;
            this.questions = [];
            return;
          }

          setTimeout(() => {
            this.index = this.index + 1;
            this.question = this.questions[this.index];
            this.date = new Date().getTime();
            this.lock = false;
            this.part.answer_count++;
            $(".question")
              .removeClass("animate__animated animate__flipOutX")
              .addClass("animate__animated animate__flipInX");
          }, 0);
        });
    },
  },
};
</script>

<style>
.option:hover {
  background-color: #1c449c;
  color: white;
  cursor: pointer;
  transition: 0.3s;
}

.option {
  margin: 10px;
}

@media (max-width: 768px) {
  .option {
    margin: 4px;
  }

  .description {
    font-size: 18px;
  }

  .option:hover {
    background-color: #fff;
    color: #333;
  }
}

.text-option {
  padding: 5px 15px;
  border-radius: 25px;
  border: 0px solid #ee2853;
  margin-bottom: 10px;
  text-align: center;
  min-width: 250px;
  max-width: 100%;
  color: white;
  font-size: 18px;
  background: linear-gradient(351deg, #ee2853, #ffa0b5);
  cursor: pointer;
  font-weight: 600;
}

.text-option:hover {
  background: linear-gradient(351deg, #ffa0b5, #ee2853);
}
</style>


// WEBPACK FOOTER //
// src/pages/TestDetail.vue